import React, { useContext, useState } from 'react'
import Input from '../Components/Shared/Input'
import Password from '../Components/Shared/Password'
import LoggedInUi from './LoggedInUi'
import { makeUnauthenticatedPOSTRequest } from '../utils/endPointCalling';
import { useCookies } from 'react-cookie';
import { Link, useNavigate } from 'react-router-dom';
import modalContext from '../context/ModalContext';

function Login() {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [cookie, setCookie] = useCookies(["token"]);
    const navigate = useNavigate();
    const {load, setLoad} = useContext(modalContext);

    const loginFunction = async ()=>{
        if(!email || !password){
            alert('Incomplete Details');
            return ;
        }
        await setLoad(true);
        console.log(load);
        const body = {email, password};
        const response = await makeUnauthenticatedPOSTRequest('/auth/login', body);
        if(response && !response.err){
            const token = response.userToReturn.token;
            const date = new Date();
            date.setDate(date.getDate()+30);
            setCookie('token', token, {path: '/', expires: date});
            setLoad(false);
            navigate('/dashboard');
        }
        else if(response.err){
            navigate('/err');
        }
    }
  return (
    <LoggedInUi>
         <div className='w-full h-full flex justify-center items-center'>
                <div style={{backgroundColor: '#D4BBDD'}} className='w-[30vmax] h-[28vmax] rounded-[0.7vmax] flex flex-col items-center'>
                    <div className='h-[18%] text-black font-bold flex justify-center items-center my-[1vmax] text-[2vmax]'>
                        Login To Your Account
                    </div>
                    <div className='flex flex-col gap-[1vmax] items-center h-[38%] my-[1vmax] justify-center'>
            <Input value={email} setValue={setEmail} label='Email ID' placeholder='Enter Your Email' />
            <Password value={password} setValue={setPassword} label='Password' placeholder='Enter Your Password' />
            </div><div className='h-[18%] my-[1vmax]'>
            <button onClick={(e)=>{
                e.preventDefault();
                loginFunction();
            }} style={{backgroundColor: '#5E376D'}} className='text-white p-[0.5vmax] rounded-[0.5vmax] text-[1.3vmax] my-[1vmax] font-bold'>Login</button></div>
            <div className='text-[1.1vmax] font-semibold p-[0.5vmax]'>Don't have an account? <Link to='/signup'><span className='font-bold cursor-pointer'>Sign Up</span></Link></div>
            </div>
            </div>
    </LoggedInUi>
  )
}

export default Login